// Address
export const addressLengthMessage =
  'Address cannot have more than 50 characters.'
export const cityLengthMessage = 'City cannot have more than 30 characters.'
export const zipLengthMessage =
  'Postal code cannot have more than 10 characters.'
export const zipMessage = 'Please provide a 5-digit zip code.'

// Email
export const emailMessage = 'Please provide an email address.'
export const emailLengthMessage = 'Email cannot have more than 250 characters.'
export const personalEmailMessage = 'Please provide a personal email address.'
export const personalEmailLengthMessage =
  'Personal email cannot have more than 250 characters.'
export const workEmailMessage = 'Please provide a work email address.'
export const workEmailLengthMessage =
  'Work email cannot have more than 250 characters.'

// Employment
export const jobTitleLengthMessage =
  'Job title cannot have more than 30 characters.'
export const workPlaceLengthMessage =
  'Work place cannot have more than 150 characters.'

// Name
export const businessNameMessage = 'Please provide a business name'
export const businessNameLengthMessage =
  'Business name cannot have more than 100 characters'
export const firstNameMessage = 'Please provide a first name.'
export const firstNameLengthMessage =
  'First name cannot have more than 20 characters.'
export const middleNameMessage =
  'Please provide a middle name, or leave this field blank.'
export const middleNameLengthMessage =
  'Middle name cannot have more than 20 characters.'
export const lastNameMessage = 'Please provide a last name.'
export const lastNameLengthMessage =
  'Last name cannot have more than 30 characters.'

// Personal Information
export const medicareNumberMessage =
  'Please provide a Medicare number in the format XXXX-XXX-XXXX (all alphanumeric)'

export const medicaidNumberMessage =
  'Medicaid number cannot have more than 15 characters (all alphanumeric)'

export const ssnMessage =
  'Please provide a social security number in the format ###-##-####'

// Phone
export const phoneMessage =
  'Please provide a phone number in the format ###-###-####'
export const alternatePhoneMessage =
  'Please provide an alternate phone number in the format ###-###-####'
export const businessPhoneMessage =
  'Please provide a business phone number in the format ###-###-####'
export const cellPhoneMessage =
  'Please provide a cell phone number in the format ###-###-####'
export const employerPhoneMessage =
  'Please provide an employer phone number in the format ###-###-####'
export const homePhoneMessage =
  'Please provide a home phone number in the format ###-###-####'
export const personalPhoneMessage =
  'Please provide a home phone number in the format ###-###-####'
export const workPhoneMessage =
  'Please provide a work phone number in the format ###-###-####'

// Not categorized messages
export const victimAgeMessage = `Please provide the victim's age to continue`
export const einMessage = 'Please provide a 9-digit employer id number (EIN).'
export const npiMessage =
  'Please provide a 10-digit national provider id (NPI).'
export const genericMessage = 'This is a required field.'
export const makeSelectionMessage =
  'This is a required field. Please make a selection to continue.'
export const maxAgeMessage = 'Please enter an age 120 or younger'
export const maxLength150Message =
  'This field cannot have more than 150 characters.'
export const maxLength500Message =
  'This field cannot have more than 500 characters.'
export const maxLength2000Message =
  'The description cannot have more than 2,000 characters.'
export const narrativeLengthMessage =
  'The description cannot have more than 10,000 characters.'
export const otherLengthMessage = 'Other cannot have more than 150 characters.'
export const childSupportLengthMessage =
  'The child support amount cannot have more than 12 numbers'
export const requiredMessage = 'This field is required.'
export const phoneRequiredMessage = 'At least one phone number is required.'
export const officeNameLengthMessage =
  'The office name cannot have more than 75 characters.'
